<template>
    <div class="scroll-table">
        <div class="table-responsive text-nowrap">
            <table class="table table-striped">
                <thead>
                <tr>
                    <th class="th-first">
                        <input style="z-index: 1;"
                               type="checkbox"
                               @change="$emit('checkAll', $event.target.checked)"
                               :checked="isAllChecked"
                        >
                    </th>
                    <th>{{ __('date_issued') }}</th>
                    <th>{{ __('document_type') }}</th>
                    <th>{{ __('document_number') }}</th>
                    <th>{{ __('content') }}</th>
                    <th class="text-right">{{ __('document_net_amount') }}</th>
                    <th class="text-right">{{ __('document_gross_amount') }}</th>
                    <th>{{ __('currency') }}</th>
                    <th class="th-before th-last text-right"></th>
                </tr>
                </thead>
                <tbody v-if="hasDocuments">
                <ContractConnectDocumentTableRow
                    v-for="(document, index) in documents"
                    :key="document.id"
                    :checked="isChecked(document.id)" :document="document"
                    :index="index"
                    :permissionsAccess="permissionsAccess"
                    @checked="$emit('checked', $event)"
                />
                </tbody>
                <tbody v-else>
                <tr class="row-show row-one-line row-odd">
                    <td class="text-center" colspan="10">{{ __('no_documents') }}</td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import ContractConnectDocumentTableRow from "./ContractConnectDocumentTableRow";
import hasPermissions from "../../../../mixins/hasPermissions";
import hasTooltips from "../../../../mixins/hasTooltips";
import inputEmit from "../../../../mixins/inputEmit";
import hasErrors from "../../../../mixins/hasErrors";

export default {
    name: "ContractConnectDocumentTable",
    components: {ContractConnectDocumentTableRow},
    props: {
        documents: {
            type: Array,
            required: true,
        },
        checkedDocuments: {
            type: Array,
            default: () => [],
        },
    },
    mixins: [hasPermissions],
    computed: {
        isAllChecked() {
            return this.hasDocuments && this.documents.length === this.checkedDocuments.length;
        },
        hasDocuments() {
            return this.documents.length > 0;
        },
    },
    methods: {
        isChecked(id) {
            return this.checkedDocuments.includes(id);
        },
    },
};
</script>

